module.exports = __webpack_public_path__ + "img/avatarSelected.f62e3f7d.png";